// Files the app hands the user (the data export, ACC-15): saved through a temporary object URL.
export function saveFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  // Let the download start before the URL goes away.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

// The data export's file name (ACC-15): webots-academy-data-<UTC date>.json, as the API names it.
export function dataExportFilename(suffix = '') {
  return `webots-academy-data${suffix}-${new Date().toISOString().slice(0, 10)}.json`;
}
